import { DepositAndWithdraw } from '@app/collections/deposit-and-withdraw'
import { metaMask, metaMaskHooks, walletConnect, walletConnectHooks } from '@app/services'
import { Web3ReactHooks, Web3ReactProvider } from '@web3-react/core'
import { MetaMask } from '@web3-react/metamask'
import { WalletConnect } from '@web3-react/walletconnect-v2'
import Head from 'next/head'

const connectors: [MetaMask | WalletConnect, Web3ReactHooks][] = [
  [metaMask, metaMaskHooks],
  [walletConnect, walletConnectHooks],
]

export default function DepositPage() {
  return (
    <>
      <Head>
        <title>Deposit and Withdraw - Coast</title>
      </Head>
      <Web3ReactProvider connectors={connectors}>
        <DepositAndWithdraw isForDrawer={false} />
      </Web3ReactProvider>
    </>
  )
}
